import React, { useCallback } from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { ProductHeader } from '@app/features';
import { OrderCancelReasonList, OrderCancelReasonDeleteModal, OrderCancelReasonCreate, OrderCancelReasonUpdate } from '@app/features/OrderCancelReason';
import { useResourceScreenHelpers } from '@app/hooks';
import { orderCancelReasonApi } from '@app/store';
import { IOrderCancelReason } from '@app/common';
import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@app/types';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const OrderCancelReasonScreen = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'OrderCancelReasonScreen'>>();

  const [readOne, { isFetching }] = orderCancelReasonApi.useLazyReadOneOrderCancelReasonsQuery();
  const [deleteOne, { isLoading }] = orderCancelReasonApi.useDeleteOneOrderCancelReasonsMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: orderCancelReason } = useResourceScreenHelpers<IOrderCancelReason>();

  const openCard = async (item: Partial<IOrderCancelReason>) => {
    onUpdate(readOne({
      filters: {
        _id: {
          $eq: item._id!
        }
      }
    }), item)
  }

  useFocusEffect(
    useCallback(() => {
      if (Boolean(route.params?._id)) {
        openCard({ _id: route.params._id, reason: "Chargement..." });
      }
    }, [route])
  );

  return (
    <MainLayout
      header={(
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::order-cancel-reasons.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title="Ajouter une raison d'annulation" />
          </CheckPermissions>
        </SettingHeader>
      )}>

      <OrderCancelReasonDeleteModal
        {...modal}
        onDelete={(orderCancelReason) => onDelete(deleteOne(orderCancelReason._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <OrderCancelReasonList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <OrderCancelReasonCreate />
            : <OrderCancelReasonUpdate
              orderCancelReason={orderCancelReason ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

